const paymentSummary = {

    allPaymentSummaries: 'List of All Payment Summaries',
    pendingPaymentSummaries: 'List of All Pending Payment Summaries',
    editPaymentSummary: 'Edit Payment Summary',
    tabGeneral: 'General',
    tabAudit: 'Audit Log',
    id: 'ID',
    summaryNumber: 'Summary Number',
    student: 'Student',
    mailAddress: 'Mail Address',
    personalAddress: 'Personal Address',
    businessAddress: 'Business Address',
    titleText: 'Title Text',
    introText: 'Introduction Text',
    closingText: 'Closing Text',
    totalAmount: 'Total Amount',
    currency: 'Currency',
    summaryDate: 'Summary Date',
    sendPaymentSummary: 'Send Payment Summary by E-Mail',
    scheduledDeliveryDate: 'Scheduled Delivery Date & Time',
    deliveryDate: 'Delivery Date & Time',
    status: 'Status',
    studentNumber: 'Student Number',
    date: 'Date',
    action: 'Action',
    searchCriteria: 'Filter Preset',
    studentNo: 'Student Number',
    show: 'Payment Summary',
    zurich: 'Zurich,',
    amountReceived: 'Amount Received:',
    invoiceNumber: 'Invoice number:',
    dateFeesReceived: 'Date fees received:',
    totalFees: 'Total fees paid to date:',
    deanOfAdminFinance: 'Dean of Administration and Finance',
    approvePaymentSummary: 'Approve payment summary',
    xPaymentSummariesApproved: '{X} payment summaries successfully approved.',
    atLeastOneSelected: 'Please select at least one payment summary to approve.',
    waitToNotify: 'Please wait for few moments as payment summaries are being emailed.',
    groupByYear: 'Group by Year',
    customGrouping: 'Custom Grouping',
    groupNumber: 'Group Number',
    group: 'Group',
    unspecifiedGroup: 'Unspecified Group',
    grandTotalLabel: 'Grand Total Label',
    totalFeesPaidToDate: 'Total fees paid to date:',
    subtotalLabels: 'Subtotal Labels',
    subtotalText: 'Subtotal Text',
    noYear: 'No Year',
    totalFeesPaid: 'Total fees paid:',
    totalFeesForYear: 'Total fees paid for the year {year}:',
    totalFeesForGroup: 'Total fees paid for group {group}:',

};

export default paymentSummary;